import { InventoryCountItem, InventoryCountSummary } from './stock.types';

/**
 * Resumen de un conteo a partir de su mapa `stockItems`. `totalItems` = ítems **en juego** (con control
 * o contados: `e !== null || c !== null`); los ítems sin control ni contar (`e === null && c === null`)
 * quedan fuera. Solo los contados (`c !== null`) cuentan variación (`c − (e ?? 0)`, tratando el ítem
 * recién controlado como base 0): coincide (0) / faltante (< 0) / sobrante (> 0). Puro.
 */
export function computeCountSummary(
  stockItems: Record<string, InventoryCountItem>,
): InventoryCountSummary {
  let totalItems = 0;
  let countedItems = 0;
  let matchItems = 0;
  let shortageItems = 0;
  let overageItems = 0;

  for (const { e, c } of Object.values(stockItems)) {
    if (e === null && c === null) {
      continue;
    }
    totalItems++;

    if (c === null) {
      continue;
    }
    countedItems++;

    const variance = c - (e ?? 0);

    if (variance === 0) {
      matchItems++;
    } else if (variance < 0) {
      shortageItems++;
    } else {
      overageItems++;
    }
  }

  return {
    totalItems,
    countedItems,
    matchItems,
    shortageItems,
    overageItems,
  };
}
